import React, { useLayoutEffect, useEffect, lazy, Suspense } from 'react';
import { useLocation, Routes, Route, Navigate } from 'react-router-dom';
import Homepage from './pages/homepage';
import { trackPageView } from './utils/analytics';
import { watchStaticHeadTwins } from './utils/head';

// Only the homepage ships in the main bundle; the other pages load on demand
// and prefetch once the browser is idle. The Router's v7_startTransition flag
// keeps the previous page mounted while a chunk loads, so the null fallback
// never shows on client-side navigation.
const Contact = lazy(() => import(/* webpackPrefetch: true */ './pages/contact/contact'));
const NotFound = lazy(() => import('./pages/notfound/NotFound'));
const ProjectPage = lazy(() => import(/* webpackPrefetch: true */ './pages/work/ProjectPage'));
const PrivacyPage = lazy(() => import(/* webpackPrefetch: true */ './pages/privacy/PrivacyPage'));

function AppRoutes() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  // Pages swap instantly. The old fade-through-white between routes left a
  // blank frame, which was glaring going from a white page to the dark hero.
  // Each page still runs its own entrance animation. A hash means the
  // incoming page wants a specific section, so leave the scroll to it.
  useLayoutEffect(() => {
    if (location.hash) return;
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  // Remove the static head tags that each page's own tags replace. A head
  // observer rather than a render effect, because lazy pages add their tags
  // after this component has already rendered.
  useEffect(() => {
    watchStaticHeadTwins();
  }, []);

  return (
    <Suspense fallback={null}>
    <Routes location={location}>
      <Route path="/" element={<Homepage />} />
      {/* About lives on the homepage now; the old URL is indexed, so keep it alive. */}
      <Route path="/About" element={<Navigate to="/#about" replace />} />
      <Route path="/Contact" element={<Contact />} />
      <Route path="/work" element={<Navigate to="/#work" replace />} />
      <Route path="/work/:id" element={<ProjectPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      {/* Without this, an unknown path matched nothing and rendered a
          blank page with no nav and no way back. */}
      <Route path="*" element={<NotFound />} />
    </Routes>
    </Suspense>
  );
}

export default AppRoutes;
